var isArray = Array.isArray;
export {
  isArray as default
};
//# sourceMappingURL=isArray.js.map
